"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME = exports.StyledComponentsTheme = void 0;
exports.StyledComponentsTheme = {
    colors: {
        primary: {
            IceterineYellow100: '#FFFD63',
            IceterineYellow75: '#FFFE8A',
            IceterineYellow50: '#FFFEB1',
            IceterineYellow25: '#FFFED8',
            IceterineYellow10: '#FFFFF0',
        },
        secondary: {
            VividSkyBlue100: '#28D4FD',
            VividSkyBlue75: '#5EDFFE',
            VividSkyBlue50: '#94EAFE',
            VividSkyBlue25: '#C9F4FE',
            VividSkyBlue10: '#EAFBFF',
            AquamarineGreen100: '#7EFED7',
            AquamarineGreen75: '#9EFEE1',
            AquamarineGreen50: '#BFFFEB',
            AquamarineGreen25: '#DEFEF5',
            AquamarineGreen10: '#F3FFFB',
            TuscanyPink100: '#C2989F',
            TuscanyPink75: '#D1B2B7',
            TuscanyPink50: '#E1CCCF',
            TuscanyPink25: '#EFE5E7',
            TuscanyPink10: '#F9F5F7',
            Xiketic100: '#0A0B1E',
            Xiketic75: '#474856',
            Xiketic50: '#85858F',
            Xiketic25: '#C1C2C6',
            Xiketic10: '#E7E7E9',
            Blue100: '#0079BF',
            Blue20: '#CCE4F2',
        },
        danger: {
            Red100: '#FF5A52',
            Red75: '#FF837D',
            Red50: '#FFADA9',
            Red25: '#FFD5D3',
            Red10: '#FFEFEE',
        },
        basic: {
            Grey100: '#090909',
            Grey75: '#474747',
            Grey50: '#838383',
            Grey40: '#9d9d9d',
            Grey25: 'rgba(9, 9, 9, 0.25)',
            Grey30: '#b6b6b6',
            Grey20: '#cecece',
            Grey10: '#e7e7e7',
            Grey05: '#f3f3f3',
            DimWhite: '#FAFAF9',
            DimWhite75: '#F0F0F0',
            White100: '#fff',
            White75: '#8f8f8f',
            White50: '#404040',
            White30: '#404040',
            White20: '#0a0a0a',
            White10: '#030303',
            Black: '#000000',
        },
        miroYellow: '#FFD02F',
        figmaPurple: '#A259FF',
        gDriveGreen: '#0F9D58',
        lightBlue: '#EEFCFF',
        darkBlue: '#0A0B1E',
        cyanGreen: '#44857B',
        cyanBlue: '#38495B',
        pinkRed: '#C3979F',
        opaque: '#B5B5B5',
        offwhite: {
            10: '#e2e2e1',
            100: '#e2dedf',
            200: '#f1f1f1',
            300: '#f2f2f2',
            400: '#f3f3f3',
            500: '#f4f4f4',
            600: '#f5f5f5',
            700: '#f6f6f6',
            800: '#f7f7f7',
            900: '#F8F8F8',
            1000: '#F9F9F9',
        },
        ufoGreen: '#29c759',
        grey: {
            900: '#1A2439',
            800: '#364457',
            700: '#6B82A2',
            300: '#F5F8FD',
            200: '#E1E4EB',
            100: '#EEF0F4',
        },
    },
    shadows: {
        elevate1: 'box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.2);',
    },
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
        xxxl: 1800,
    },
    zIndex: {
        layer: {
            0: 0,
            1: 100,
            2: 200,
            3: 300,
            5: 500,
            10: 1000,
            13: 1300,
        },
    },
    spacing: function (x) {
        return x * 8;
    },
    helpers: {
        hover: {
            elevate: "\n          transform: translate(-2px, -2px);\n          box-shadow: 4px 4px 0px 0 rgba(0, 0, 0, 0.2);\n        ",
        },
    },
    typography: {
        h1: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 32px;\n        line-height: 40px;\n      ",
        h2: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 20px;\n        line-height: 24px;\n      ",
        h3: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 18px;\n        line-height: 22px;\n      ",
        h4: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 16px;\n        line-height: 20px;\n      ",
        h5: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 20px;\n      ",
        h6: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 22px;\n        color: #737373;\n      ",
        body1: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 20px;\n        line-height: 24px;\n      ",
        body2: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 16px;\n        line-height: 20px;\n      ",
        body3: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 22px;\n      ",
        formInput: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 18px;\n        line-height: 22px;\n      ",
        placeholder: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 16px;\n        line-height: 20px;\n        color: #B3B3B3;\n      ",
        overline: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 17px;\n        color: #000000;\n      ",
        button: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 20px;\n      ",
        textButton: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 0.875rem;\n        line-height: normal;\n      ",
        label: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 12px;\n        line-height: 16px;",
        labelTiny: "\n        font-family: Inter;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 10px;\n        line-height: 12px;",
        title: "\n        font-family: Inter;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 29px;\n        letter-spacing: 0em;\n        text-align: center;\n      ",
    },
};
exports.THEME = exports.StyledComponentsTheme;
//# sourceMappingURL=StyledComponentsTheme.js.map